import { createFocusTrap, Options } from 'focus-trap';
import { useEffect, useRef } from 'react';

type Config = {
  focusElm: HTMLElement | null | undefined;
  isActive: boolean;
  clickOutsideDeactivates?: () => boolean;
  trapOptions?: Options;
  onDeactivate?: () => void;
};

const useModalFocusTrap = (config: Config) => {
  const trapOptions = useRef(config.trapOptions);
  const clickOutsideDeactivatesRef = useRef(config.clickOutsideDeactivates);
  const onPostDeactivateRef = useRef(config.onDeactivate);

  trapOptions.current = config.trapOptions;
  clickOutsideDeactivatesRef.current = config.clickOutsideDeactivates;
  onPostDeactivateRef.current = config.onDeactivate;
  useEffect(() => {
    if (!config.focusElm || !config.isActive) return;
    try {
      const trap = createFocusTrap(
        [config.focusElm, '#ai-chat-portal', '.Toastify'],
        {
          clickOutsideDeactivates: clickOutsideDeactivatesRef.current,
          onPostDeactivate: onPostDeactivateRef.current,
          // escapeDeactivates -> handle it outside on the modal component
          // for some reason the event here always shows the "defaultPrevented" as true
          escapeDeactivates: false,
          ...trapOptions.current,
        },
      );

      trap.activate();

      return () => {
        try {
          trap.deactivate();
        } catch (e) {
          console.error('useModalFocusTrap failed to deactivate', e);
        }
      };
    } catch (e) {
      console.error('useModalFocusTrap failed to activate', e);
    }
  }, [config.focusElm, config.isActive]);
};

export default useModalFocusTrap;
